import { v4 as uuidv4 } from "uuid";
import { SET_ALERT, REMOVE_ALERT, CLEAR_ALERTS } from "./types";

let isVisible = false;

/** Clears the alert from Redux and allows a new `setAlert` to show. */
export const removeAlert = (id) => (dispatch) => {
  dispatch({
    type: REMOVE_ALERT,
    payload: id,
  });
  isVisible = false;
};

/** Clears all alerts (e.g. on SPA route change so messages do not persist). */
export const clearAlerts = () => (dispatch) => {
  dispatch({ type: CLEAR_ALERTS });
  isVisible = false;
};

export const setAlert = (msg, alertType) => (dispatch) => {
  const id = uuidv4();
  if (isVisible) {
    return;
  }
  isVisible = true;
  dispatch({
    type: SET_ALERT,
    payload: { msg, alertType, id },
  });
};
